import React from 'react';
import { Create } from 'react-admin';
import { getTransform } from '../rateSettingsTransform';
import RateSettingsForm from '../shared/rate-settings-form/RateSettingsForm';

const StateLocationTypeRateSettingCreate = () => (
  <Create transform={getTransform(['state_id', 'location_type_id'], 'settings')}>
    <RateSettingsForm settingsField="settings" />
  </Create>
);

export default StateLocationTypeRateSettingCreate;
